<template>
  <v-table
      :count="count"
      :list="list"
      :is-loading="isLoading"
      :push-list="RouteConfig.courseDeletedList.push"
      default-order-by="start_time"
      :query-list="queryList"
      :is-show-store-select="isHeadOffice"
      :is-store-select-clearable="true"
      :is-show-quick-time-tab="true"
      :is-show-quick-time-tab-next-week="true"
      :is-show-teacher-select="true"
      :is-show-select-card-type-id="true"
      :is-show-select-course-column-id="true"
      :show-summary="true"
      :picker-options="pickerOptionsOfAfterSystemStartDay"
      :summary-title="isPc ? '大课平均人数' : '均数'"
  >
    <el-table-column type="expand" v-if="!isPc">
      <template v-slot="{ row }">
        <el-form label-position="left" inline class="table-expand">
          <el-form-item label="添加时间">
            <span>{{ row.add_time | timeToYmdHi }}</span>
          </el-form-item>

          <el-form-item label="开始时间">
            <span>{{ row.start_time | timeToYmdHi }}</span>
          </el-form-item>

          <el-form-item label="结束时间">
            <span>{{ row.end_time | timeToYmdHi }}</span>
          </el-form-item>

          <el-form-item label="课程类型">
            <span>{{ row.card_type_name }}</span>
          </el-form-item>

          <el-form-item label="已预约">
            <span>{{ row.student_count }}</span>
          </el-form-item>

          <el-form-item label="试课">
            <span>{{ row.trial_count }}</span>
          </el-form-item>

          <el-form-item label="排队中">
            <span>{{ row.wait_count }}</span>
          </el-form-item>

          <el-form-item label="已打卡">
            <span>{{ row.signed_count }}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>

    <v-column-time value="删除时间" field="is_del" v-if="isPc"/>

    <v-column-time value="开始时间" field="start_time" sortable=""/>
    <v-column-time value="结束时间" field="end_time" sortable="" v-if="isPc"/>

    <el-table-column v-if="isHeadOffice" label="所属门店" prop="store_name"/>
    <v-column-avatar label="课程老师" avatar-key="teacher_avatar" nickname-key="teacher_names"/>
    <el-table-column label="课程名称" prop="course_name"/>
    <el-table-column label="课程类型" prop="card_type_name" v-if="isPc"/>
    <el-table-column label="已预约" prop="student_count" type="average"/>
    <el-table-column label="试课" prop="trial_count" type="average" v-if="isPc"/>
    <el-table-column label="排队中" prop="wait_count" type="average" v-if="isPc"/>
    <el-table-column label="已打卡" prop="signed_count" type="average"/>

    <el-table-column label="操作" width="250px">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.courseEdit.to(row.id)"/>
        <v-list-button icon="signed-in" name="签到" :to="RouteConfig.courseReserve.to(row.id)"/>

        <v-popover
            name="恢复"
            icon="restore"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="小程序将恢复该课程，但不会自动恢复已取消的预约，确定要继续操作吗？"
        >
          <v-popover-item icon="copy" name="复制模板" :to="RouteConfig.courseAdd.to('', { id:  row.id })"/>
          <v-popover-item
              icon="mini-app-qr-code"
              name="小程序码"
              @click="getQrCode(row.id, true)"
              :is-loading="isGetting[row.id]"
          />
          <v-popover-item icon="trial" name="添加试课" :to="RouteConfig.courseTrial.to(row.id)"/>
          <v-popover-item icon="reserve-manage" name="预约管理" :to="RouteConfig.courseManage.to(row.id)"/>
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>课程老师</span>
              <v-avatar-nickname
                :value="v.teacher_avatar"
                :nickname="v.teacher_names"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>开始时间</span>
              <span>{{ v.start_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>结束时间</span>
              <span>{{ v.end_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课程名称</span>
              <span>{{ v.course_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课程类型</span>
              <span>{{ v.card_type_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>已预约</span>
              <span>{{ v.student_count }}</span>
            </div>
            <div class="list-item-detail">
              <span>试课</span>
              <span>{{ v.trial_count }}</span>
            </div>
            <div class="list-item-detail">
              <span>排队中</span>
              <span>{{ v.wait_count }}</span>
            </div>
            <div class="list-item-detail">
              <span>已打卡</span>
              <span>{{ v.signed_count }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.courseEdit.to(v.id)"/>
              <v-list-button icon="signed-in" name="签到" :to="RouteConfig.courseReserve.to(v.id)"/>

              <v-popover
                name="删除"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="小程序将下线该课程，但不会自动取消预约，确定要继续操作吗？"
              >
                <v-popover-item icon="copy" name="复制模板" :to="RouteConfig.courseAdd.to('', { id: v.id })"/>
                <v-popover-item
                  icon="mini-app-qr-code"
                  name="小程序码"
                  @click="getQrCode(v.id)"
                  :is-loading="isGetting[v.id]"
                />
                <v-popover-item icon="trial" name="添加试课" :to="RouteConfig.courseTrial.to(v.id)"/>
                <v-popover-item icon="reserve-manage" name="预约管理" :to="RouteConfig.courseManage.to(v.id)"/>
              </v-popover>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <span>大课平均人数</span>
              <span>{{ average_attendance }} 人</span>
            </div>
          </div>

          <v-pagination
            :count="count"
            :page="queryList.page"
            :size="queryList.size"
            @page-change="handlePageChange"
          />
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>

        <v-qr-code v-model="qrCode.src"/>

      </section>
    </template>

  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, restore, getQrCode } from '@/api/course';
import { getDay, pickerOptionsOfAfterSystemStartDay, getLegalQueryList } from '@/utils/formats';
import { checkYmdIsSinceSetUp } from '@/utils/validate';
import { cardTypes } from "@/enums/cardTypes";
import { dividedBy } from "@/filters";

export default {
  name: RouteConfig.courseDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    isGetting: {},
    count: 0,
    average_attendance: 0,
    qrCode: {
      src: '',
    },
    list: [],
    timeLimit: [],
    queryList: {
      store_id: '',
      course_column_id: '',
      teacher_ids: [],
      start_date: '',
      end_date: '',
      is_asc: 0,
      page: 1,
      size: 10,
      card_type_id: 0,
    },
    pickerOptionsOfAfterSystemStartDay,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isHeadOffice',
      'isManager',
      'isReceptionist',
      'isMobile',
      'isPc',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
    queryList(queryList) {
      if (!this.isMobile) return;
      this.timeLimit = [queryList.start_date, queryList.end_date];
    },
  },
  methods: {
    refresh(query = this.queryList) {
      RouteConfig.courseList.push(query);
    },
    hideQrcode() {
      this.qrCode.src = '';
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleTeacherChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    async getQrCode(id, isOpenWindow = false) {
      if (this.isGetting[id]) return;

      this.$set(this.isGetting, id, true);
      const { isError, data } = await getQrCode(id);
      this.$set(this.isGetting, id, false);
      if (isError || !data.qr_code) return;
      if (isOpenWindow) return window.open(data.qr_code);

      this.qr_code = data.qr_code;
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsSinceSetUp(query.start_date);
      const endDateIsValid = checkYmdIsSinceSetUp(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else if (next) {
        queryList.start_date = '';
        queryList.end_date = '';
      }
      queryList.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      let student_count = 0;
      data.list.forEach(item => {
        if (item.card_type_id === cardTypes.personal.value) {
          item.isNotSummary = true;
        } else {
          student_count += item.student_count;
        }
      });

      this.count = data.count;
      this.average_attendance = dividedBy(student_count, data.list.length);
      this.list = data.list;
    },
    async handleDelete({ id, update_time }) {
      if (!id) return this.$message.warning('缺少课程 ID，无法还原课程！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.error('缺少课程信息，无法还原！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await restore(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
  beforeMount() {
    const today = getDay();
    this.queryList.start_date = today;
    this.queryList.end_date = today;
    this.timeLimit = [this.queryList.start_date, this.queryList.end_date];
    this.load();
  },
};
</script>
